import { createSlice } from "@reduxjs/toolkit";
import { CryoboxListState } from "./types";
import { StoreStatus } from "../../core/types/common.types";
import { findCryoboxesThunk } from "./thunks";

// Initial State
const initialState: CryoboxListState = {
  errors: null,
  status: StoreStatus.IDLE,
  values: null,
  response: null,
};

// Slice
export const cryoboxListSlice = createSlice({
  name: "cryoboxList",
  initialState,
  reducers: {
    setValues: (state, action) => ({
      ...state,
      values: action.payload,
    }),
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: {
    [findCryoboxesThunk.pending.type]: (state, action) => {
      state.status = StoreStatus.BUSY;
    },
    [findCryoboxesThunk.fulfilled.type]: (state, action) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    },
    [findCryoboxesThunk.rejected.type]: (state, action) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    },
  },
});

// Action creators
export const { reset, setValues } = cryoboxListSlice.actions;
export * from "./thunks";
export * from "./selectors";
export default cryoboxListSlice.reducer;
